import { pureFilters } from '@/lib/agreement/filters';

export default {
	props: {
		agreementData: {
			type: Object,
			required: true,
		},
	},
	computed: {
		childrenNames() {
			return this.agreementData.children.map(pureFilters.preferredName);
		},
		// Under 18 at any time in the agreement year (see filters.isUnder18InYear).
		childrenUnder18Names() {
			const year = this.agreementData.agreement && this.agreementData.agreement.year;
			return pureFilters.childrenUnder18(this.agreementData.children || [], year).map(pureFilters.preferredName);
		}
	},
};
